<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="دفع">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div class="offline_detail" ref="imageTofile" v-if="pay_info && order_info">
          <div class="offline_detail_t">
            <div class="title">حساب التحويل البنكي</div>
            <div class="action">
              <button id="download" type="button" @click="toImage"><span>تحميل</span></button>
            </div>
          </div>
          <div class="offline_detail_b">

            <div class="containers" v-for="item in order_info.goods_list" v-bind:key="item.goods_id" @click="$router.push({name:'HomeGoodsdetail',query:{goods_id:item.goods_id}})">
              <img class="photo" v-bind:src="'data:image/png;base64,'+ item.image_url" alt="img" />
              <div class="right-wrapper">
                <label class="title">{{ item.goods_name }}</label>
                <!--                <label class="property">{{ item.goods_spec }}</label>-->
                <div class="desc-wrapper">
                  <div>
                    <label class="price">$ {{ item.goods_price }}</label>
                    <label class="count">x{{ item.goods_num }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="offline_info">
              <table class="offline_table">
                <tr>
                  <td>Buyer:</td>
                  <td>{{order_info.member_nickname}}</td>
                </tr>
                <tr class="even">
                  <td>Payment type:</td>
                  <td>
                    <p v-if="order_info.initial_state == '0' || order_info.initial_state == '1'">Initial payment ({{order_info.initial_ratio}}%)</p>
                    <p v-else>Balance payment ({{order_info.balance_initial_ratio}}%)</p>
                  </td>
                </tr>
                <tr>
                  <td>Payment total:</td>
                  <td>
                    <b style="color: #27a9e3;" v-if="order_info.initial_state == '0' || order_info.initial_state == '1'">
                      USD
                      {{order_info.initial_amount}}
                    </b>
                    <b style="color: #27a9e3;" v-else>
                      USD
                      {{order_info.balance_amount}}
                    </b>
                  </td>
                </tr>
<!--                <tr>
                  <td>Payment currency:</td>
                  <td><b>USD</b></td>
                </tr>-->
                <tr class="even">
                  <td>Beneficiary name:</td>
                  <td>{{order_info.store_joinin_info.company_name}}</td>
                </tr>
                <tr>
                  <td>Beneficiary address:</td>
                  <td>{{order_info.store_joinin_info.company_address_detail}}</td>
                </tr>
                <tr class="even">
                  <td>Bank Account:</td>
                  <td>{{order_info.store_joinin_info.bank_account_name}}</td>
                </tr>
                <tr>
                  <td>Bank Name:</td>
                  <td>{{order_info.store_joinin_info.bank_name}}</td>
                </tr>
                <tr class="even">
                  <td>Bank ADDRESS:</td>
                  <td>{{order_info.store_joinin_info.bank_address}}</td>
                </tr>
                <tr>
                  <td>SWIFT CODE:</td>
                  <td>{{order_info.store_joinin_info.bank_swift_code}}</td>
                </tr>
                <tr class="even">
                  <td>BANK CODE (FOR CHATS ONLY):</td>
                  <td>{{order_info.store_joinin_info.bank_account_number}}</td>
                </tr>
                <tr>
                  <td>Branch Code:</td>
                  <td>{{order_info.store_joinin_info.bank_branch_code}}</td>
                </tr>

                <tr>
                  <td>Estimated volume:</td>
                  <td>
                    {{order_info.goods_volume_total}} m³
                    <br><span style="color: #ff7737;font-size: 12px;">For reference only, actual production confirmation shall prevail</span>
                  </td>
                </tr>
                <tr>
                  <td>Gross weight:</td>
                  <td>
                    {{order_info.goods_weight_total}} kg
                    <br><span style="color: #ff7737;font-size: 12px;">For reference only, actual production confirmation shall prevail</span>
                  </td>
                </tr>

                <tr class="even">
                  <td>Remark:</td>
                  <td>
                    {{order_info.order_sn}}<br>
                    <span style="color: #ff7737;font-size: 12px;">Please note the order number when making payment</span>
                  </td>
                </tr>
              </table>
            </div>
            <div class="offline_bot">
              <dl>
                <dt>Notice</dt>
                <dd>You will ONLY be covered by Trade Assurance when you make payment to this account shown above.</dd>
              </dl>
            </div>
            <div class="offline_print_date">
              <span>Print date:</span>
              <span style="unicode-bidi:bidi-override;">{{order_info.print_date}}</span>
            </div>
          </div>
        </div>
        <div class="offline_upload_content">
          <div class="offline_detail_t">
            <div class="title">تحميل سند الدفع</div>
          </div>
          <div class="offline_detail_b">
            <div class="offline_info" style="margin-top: 0;">
              <div class="offline_info_img" @change="uploadImage('initial_img',$event)" v-if="order_info.initial_state < 2">
                <div v-if="order_info.initial_img_url" class="user-avatar">
                  <img :src="order_info.initial_img_url">
                </div>
                <div v-else>
                  <img src="../../../assets/image/no_image.jpg">
                </div>
                <input type="file" accept="image/*">
              </div>
              <div class="offline_info_img" @change="uploadImage('balance_img',$event)" v-else>
                <div v-if="order_info.balance_img_url" class="user-avatar">
                  <img :src="order_info.balance_img_url">
                </div>
                <div v-else>
                  <img src="../../../assets/image/no_image.jpg">
                </div>
                <input type="file" accept="image/*">
              </div>
              <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
                <div class="common-header-wrap">
                  <mt-header title="قص الصورة" class="common-header">
                    <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
                    <mt-button slot="right" @click="useCrop">يستخدم</mt-button>
                  </mt-header>
                </div>
                <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
              </mt-popup>
            </div>
          </div>
        </div>
        <mt-button class="ds-button-large" type="primary" v-on:click="submit">يقدم</mt-button>
    </div>
</template>

<script>
import $ from 'jquery'

import { mapState } from 'vuex'
import {Toast, MessageBox, Indicator} from 'mint-ui'

import html2canvas from "html2canvas"
import {getOrderpayOfflineInfo,uploadPaymentPic,updatePaymentInfo} from '../../../api/memberBuy'
import { VueCropper } from 'vue-cropper'

export default {
  components: {
    VueCropper
  },
  name: 'pay',
  data () {
    return {
      pay_sn: this.$route.query.pay_sn ? this.$route.query.pay_sn : '',
      // 订单支付显示的数据
      pay_info: null,
      order_info: [],
      showNotice: 0,
      notice: this.$route.query.notice,
      ifLoaded: false,
      showCrop: false,
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
    }
  },
  computed: {
    ...mapState({
      token: state => state.member.token

    })
  },
  created: function () {
    this.getMemberPayInfo()
  },
  watch: {
    showNotice: function (val) {
      if (val && this.notice) {
        MessageBox.confirm('If you have completed the payment, please click the "Complete Payment" button, if you have not completed the payment, please click "Repay" to initiate the payment again', 'Confirm whether the payment is complete', { cancelButtonText: 'Pay again', confirmButtonText: 'Payment completed' }).then(action => {
          this.goNext()
        })
      }
    },
    ifLoaded: function (val) {
      if (val) {
        this.getPaymentList()
      }
    }
  },
  methods: {
    goBack () {
      if (this.notice) {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    setClass(code){
        let obj = {}
        obj["icon " + code] = true
        return obj
    },
    goNext () {
      this.$router.push({ name: 'MemberOrderList' })
    },
    getMemberPayInfo () {
      let _this = this
      getOrderpayOfflineInfo(
          this.pay_sn
      ).then((res) => {
        if (res.code === 10000) {
          /*console.log(res)
          return false*/
          this.pay_info = res.result.pay_info
          this.order_info = res.result.order_info
        }
        this.showNotice = 1
      }).catch(function (error) {
        if (error.code === 12001) { // 订单已经支付
          _this.goNext()
        } else {
          Toast(error.message)
        }
      })
    },
    submit () {
      let _this = this
      if(this.order_info.initial_img == '' && this.order_info.balance_img == ''){
        Toast("الرجاء تحميل قسيمة الدفع")
        return false
      }
      updatePaymentInfo(this.order_info).then(res => {
        //this.memberEdit(this.member_info)
        Toast(res.message)
        setTimeout(function () {
          _this.$router.push({ name: 'MemberOrderList' })
        }, 2000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 页面元素转图片
    toImage() {
      $('.action').hide()
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png')
        let f = 'Account_' + (new Date).getTime()
        this.downloadFile(f, url)
        //Toast('图片已经生成，请长按保存')
      })
      $('.action').show()
    },
    downloadFile (fileName, content) {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(content)
      let evt = document.createEvent("HTMLEvents")
      evt.initEvent("click", true, true)
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}))
    },
    base64ToBlob(code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {type: contentType})
    },
    dropImage (type) {
      this.order_info.initial_img = ''
      this.$forceUpdate()
    },
    useCrop () {
      let type = ''
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()
        formdata.append('file', files)
        formdata.append('name', 'file')
        Indicator.open()
        uploadPaymentPic(formdata).then(res => {
          if(this.order_info.initial_state < 2){
            this.order_info.initial_img = res.result.path
            this.order_info.initial_img_url = res.result.url
          }else{
            this.order_info.balance_img = res.result.path
            this.order_info.balance_img_url = res.result.url
          }
          this.showCrop = false
          Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    uploadImage (type, event) {
      let that = this
      this.cropType = type
      let file = event.target.files[0]
      if (!/\.(jpg|png|gif|bmp|jpeg)$/.test(file.name.toLowerCase())) {
        Toast('Please upload the file in picture format')
        return
      }
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        //that.order_info.initial_img = e.target.result
        that.$forceUpdate()
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
    .image_tofile {
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
      .tip{
        position: absolute;
        width: 100vw;
        text-align: center;
        top: 20%;
      }
    }
    .btn {
      position: absolute;
      top: 30%;
    }
    #testImg {
      width: 100vw;
      height: 100vh;
      overflow: hidden;
    }
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        min-height: 100vh;
        background-color: $cardbgColor;
    }
    .offline_detail{
      width: 95%;
      margin: 10px auto 0;
      border: 1px solid #e6e7eb;
    }
    .offline_detail_t{
      padding: 0 10px;
      height: 42px;
      line-height: 40px;
      overflow: hidden;
      border-bottom: 1px solid #e6e7eb;
      background-color: #f9f9f9;
    }
    .offline_detail_t .title{
      display: inline;
      font-size: 14px;
      color: #333333;
    }
    .offline_detail_t .action{
      float: left;
    }
    .offline_detail_t .action #download{
      border-radius: 14px;
      padding: 0 15px;
      height: 24px;
      font-size: 14px;
      border-width: 1px;
      border-style: solid;
      background-color: #fff;
      border-color: #ff4040;
      color: #ff4040;
    }
    .offline_detail_b{
      padding: 5px;
      background-color: #fff;
    }
    .offline_detail_b .offline_tips{
      font-size: 12px;
      padding: 5px;
      border: 1px solid #7abee8;
    }
    .offline_detail_b .offline_info{
      margin-top: 5px;
      overflow: hidden;
    }
    .offline_detail_b .offline_info .offline_table{
      border-collapse: collapse;
      border-spacing: 0;
    }
    .offline_detail_b .offline_info .offline_table td{
      padding: 5px 5px;
      font-size: 12px;
      color: #666666;
      border: 1px solid #eeeeee;
    }
    .offline_detail_b .offline_info .offline_table td b{
      color: #333;
    }
    .offline_detail_b .offline_bot{
      padding: 0px 0px 5px;
      margin-top: 5px;
      background-color: #f7f8fa;
      overflow: hidden;
    }
    .offline_detail_b .offline_bot dl{
      overflow: hidden;
    }
    .offline_detail_b .offline_bot dl dt{
      position: relative;
      height: 18px;
      line-height: 18px;
      overflow: hidden;
      padding: 0 7px 0 10px;
      display: inline-block;
      background-color: #e3eaf7;
      color: #27A9E3;
      font-size: 12px;
    }
    /*.offline_detail_b .offline_bot dl dt:after {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 0;
      height: 0;
      border-color: #e3eaf7 #e3eaf7 #e3eaf7 #f7f8fa;
      border-style: solid;
      border-width: 9px 0px 9px 8px;
      content: "";
    }*/
    .offline_detail_b .offline_bot dl dd{
      line-height: 18px;
      font-size: 13px;
      padding: 0 10px;
      color: #666;
    }
    .offline_detail_b .offline_print_date{
      padding: 5px 0 0;
      color: #666;
      text-align: left;
      font-size: 12px;
      line-height: 16px;
    }
    .offline_upload_content{
      width: 95%;
      margin: 10px auto 0;
      border: 1px solid #e6e7eb;
    }
    .offline_upload_content .offline_print_body{}
    .offline_info_img{
      width: 8rem;
      height: 8rem;
      margin: 0 auto;
      padding: 20px 0;
      text-align: center;
      position: relative;
    }
    .offline_info_img::before{
      position: absolute;
      font-size: 1.5rem;
      line-height: 8rem;
      left: 50%;
      margin-left: -0.75rem;
      color: rgba(0, 0, 0, 0.5);
      z-index: 2;
    }
    .offline_info_img input{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .offline_info_img img{
      width: 100%;
      height: 100%;
    }

    .containers {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: stretch;
      background-color: #fff;
      border: 1px solid #eeeeee;
      margin-top: 5px;
    }
    .photo {
      width:4rem;
      height:4rem;
      margin:0.75rem 0.5rem 0.75rem 0.75rem;
      border: 1px solid #eeeeee;
      flex-basis:4rem;
      flex-shrink: 0;
    }
    .right-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      padding: 0 0.75rem 0 0;
      width: 100%;
      overflow: hidden;
    }
    .title {
      height: 2.4rem;
      line-height: 0.8rem;
      margin-top:0.75rem;
      color: #333;
      font-size:0.6rem;
      overflow: hidden;
      /*text-overflow: ellipsis;
      white-space: nowrap;*/
    }
    .property {
      font-size:0.65rem;
      color: #7c7f88;
      padding-top:0.5rem;
    }
    .count {
      color: #7c7f88;
      font-size:0.65rem;
      margin-right:0.5rem;
      float: right;
    }
    .desc-wrapper {
      height:1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-top: 0.4rem;
      overflow: hidden;
    }
    .price {
      color: $primaryColor;
      font-size:0.8rem;
      margin-left: 0;
      float: right;
    }
    .count {
      color: #7c7f88;
      font-size:0.8rem;
      margin-left:0.5rem;
    }

</style>
